import { Box, ResponsiveLayout, Typography } from "@bca/ui-library";

export const TrackedVehiclesTitle = () => {
  return (
    <Box
      height="124px"
      width="100%"
      backgroundColor="secondary-light-grey"
      display="flex"
      alignItems="center"
    >
      <ResponsiveLayout display="flex" justifyContent="flex-start">
        <Typography variant="h4" fontWeight="bold">
          Tracked Vehicles
        </Typography>
      </ResponsiveLayout>
    </Box>
  );
};
